/**
 * SortableActivityCard - Wrapper around ActivityCard that adds drag-and-drop functionality
 */

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { Activity } from '../../types/activity';
import type { Day } from '../../types/trip';
import ActivityCard from './ActivityCard';

interface SortableActivityCardProps {
  activity: Activity;
  index: number;
  onEdit?: () => void;
  onDelete?: () => void;
  onMoveToDay?: (dayIndex: number) => void;
  onUnschedule?: () => void;
  onTogglePrimary?: () => void;
  availableDays?: Day[];
  onClick?: () => void;
}

export default function SortableActivityCard({ activity, index, onEdit, onDelete, onMoveToDay, onUnschedule, onTogglePrimary, availableDays, onClick }: SortableActivityCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: activity.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      <ActivityCard
        activity={activity}
        index={index}
        onEdit={onEdit}
        onDelete={onDelete}
        onMoveToDay={onMoveToDay}
        onUnschedule={onUnschedule}
        onTogglePrimary={onTogglePrimary}
        availableDays={availableDays}
        dragHandleProps={listeners}
        onClick={onClick}
      />
    </div>
  );
}
